export default {
  compareHub: {
    seo: {
      title: 'مقارنة برامج اللوجستيات | Geofleet — منصة وكيلية للتنفيذ',
      description:
        'قارن Geofleet مع محسّنات المسارات وأدوات آخر ميل ومنصات التوصيل المؤسسية. جدول نظرة عامة وصفحات مخصصة لكل مورّد — منصة لوجستيات وكيلية للتنفيذ الفعلي.',
    },
    breadcrumb: 'مقارنة',
    hero: {
      lockupPartner: 'منصات أخرى',
      eyebrow: 'مقارنة المنصات',
      h1Before: 'قارن برامج اللوجستيات — اختر طبقة تنفيذ ',
      h1Highlight: 'وكيلية',
      h1After: '',
      leadBefore: 'معظم الأدوات',
      leadEmphasis1: 'تخطط أو تُشعر فقط',
      leadMiddle: '. صُمم Geofleet لـ',
      leadEmphasis2: 'تشغيل العمليات',
      leadAfter:
        ': وكلاء ذكاء اصطناعي في مركز قيادة واحد يحافظون على توافق السائقين والناقلين والعملاء مع تغيّر الظروف — دون لوحات متناثرة وإعادة تخطيط يدوية.',
      ctaTable: 'عرض جدول المقارنة',
      ctaTrial: 'ابدأ الآن',
      ctaDemo: 'احجز عرضاً',
    },
    howToLabel: 'كيفية استخدام هذه الصفحة',
    steps: {
      overview: {
        title: 'ابدأ بالنظرة العامة',
        body: 'شاهد في جدول واحد كيف يختلف Geofleet عن مسارات التوصيل والأنظمة التقليدية النموذجية.',
      },
      vendor: {
        title: 'تعمّق في مورّدك',
        body: 'اختر الأداة التي تستخدمها اليوم — كل صفحة مقارنة Geofleet مقابل المورّد بالتفصيل.',
      },
      validate: {
        title: 'تحقق على شبكتك',
        body: 'احجز عرضاً لربط المحاور والناقلين والأحجام بمركز القيادة ووكلاء الذكاء الاصطناعي.',
      },
    },
    pills: {
      command: {
        title: 'مركز قيادة الذكاء الاصطناعي',
        sub: 'الوكلاء ينسّقون الإرسال والمسارات والاستثناءات معاً',
      },
      live: {
        title: 'تنفيذ مباشر',
        sub: 'التخصيص والمسارات تتحدث مع الشبكة',
      },
      stack: {
        title: 'قصة الأميال كاملة',
        sub: 'محاور وبوابات وتتبع وتحليلات في منصة واحدة',
      },
    },
    tableSection: {
      title: 'لمحة سريعة: تنفيذ وكيلي مقابل أنظمة نموذجية',
      description:
        'المورّدون يختلفون — استخدم الشبكة أدناه لأداتك بالضبط. يلخص هذا الجدول فجوات متكررة عندما تتجاوز الفرق حلولاً نقطية وتحتاج طبقة أتمتة عبر الشبكة.',
      badge: 'رؤية مجمّعة شفافة',
    },
    aggregateFeatures: [
      'مركز قيادة الذكاء الاصطناعي ووكلاء الذكاء الاصطناعي',
      'تخصيص تلقائي للسائقين والناقلين',
      'تخطيط مسارات وكيلي',
      'أول ميل / آخر ميل',
      'شحنات متعددة الأرجل',
      'بوابة الشاحن',
      'تتبع فوري',
      'تنبيهات وإشعارات بالذكاء الاصطناعي',
      'تحليلات',
    ],
    aggregateGeofleetCells: [
      'مركز قيادة ذكاء اصطناعي مع وكلاء ذكاء اصطناعي: تنسيق مستقل متعدد الخطوات ومعالجة استثناءات وتحسين مستمر — وليس روبوت محادثة مضافاً أو لوحة ثابتة.',
      'تخصيص تلقائي بالذكاء الاصطناعي للسائقين والناقلين في نموذج واحد: السعة والقرب واتفاقية مستوى الخدمة والتكلفة والمهارات والظروف المباشرة محدّثة من مركز القيادة.',
      'تخطيط مسارات مدفوع بالتعلم الآلي وإعادة تحسين ديناميكية للزحام والطلبات الجديدة والمحاولات الفاشلة والمحاور والقيود — دون جداول إعادة تخطيط يدوية طويلة.',
      'أول ميل ووسط ميل وآخر ميل في منصة أتمتة لوجستية واحدة.',
      'نمذجة تدفقات متعددة الأرجل ومحاور معقدة — وليس حلقات سائق واحد فقط.',
      'بوابات مخصصة للشاحن والناقل للحجز والرؤية والتعاون.',
      'تتبع مباشر وتوقعات وقت وصول وتجربة علامة تجارية من نفس طبقة الذكاء الاصطناعي التشغيلية.',
      'تنبيهات ذكية ذات أولوية وإشعارات تُطلقها الذكاء الاصطناعي لمخاطر اتفاقية مستوى الخدمة والتأخير والسعة والاستثناءات.',
      'تحليلات تشغيلية ورؤى بمساعدة الذكاء الاصطناعي عبر المحاور والناقلين والمسارات والسائقين واتفاقيات مستوى الخدمة.',
    ],
    aggregateCompetitorCells: [
      'تقدم معظم المنتجات لوحات أو قواعد أو محادثة مضافة — قليل يوفّر وكلاء ذكاء اصطناعي أصليين مستقلين عبر الإرسال والمسارات وإعادة التخطيط والاستثناءات في برج واحد.',
      'تعيين السائق أو المهمة شائع؛ محرك واحد يحسّن السائقين والناقلين معاً ضد اتفاقيات مستوى الخدمة المباشرة لا يزال نادراً.',
      'كثيرون يحسّنون مسارات ثابتة أو دفعات يومية؛ أقل يعيد التخطيط باستمرار عندما يغيّر الزحام والفشل والمحاور والطلبات الجديدة اللوحة في الوقت الفعلي.',
      'آخر ميل والمراسلة المحلية جيدة التغطية؛ أول ووسط ميل وتسليم الشبكة غالباً يحتاج أدوات أو تكامل إضافي.',
      'حلقات سائق ذات ساق واحدة نموذجية؛ نمذجة محور-إلى-محور ومتعددة الأرجل كأساس أقل شيوعاً خارج المجموعات المؤسسية.',
      'توجد بوابات شاحن وناقل في بعض المكدسات، لكن العمق وتجربة المستخدم والتكافؤ مع أدوات المشغّل يختلفان كثيراً.',
      'التتبع ووقت الوصول أساسيان؛ ربط تجربة العميل بنفس طبقة الذكاء الاصطناعي التي تدفع الإرسال أقل شمولاً.',
      'الإشعارات غالباً قوالب؛ تنبيهات استباقية ذات أولوية مدفوعة بمخاطر اتفاقية مستوى الخدمة عبر الشبكة عتبة أعلى.',
      'مؤشرات مسار أو مهمة شائعة؛ تحليلات موحّدة عبر المحاور والناقلين والأرجل واتفاقيات مستوى الخدمة في منصة أتمتة واحدة أصعب إيجادها.',
    ],
    vendorsSection: {
      eyebrow: 'صفحات مقارنة مباشرة',
      title: 'اعثر على مورّدك الحالي',
      description:
        'كل رابط يفتح مقارنة مخصصة: نقاط قوة المورّد، أين يتجاوز Geofleet، ومتى تكون منصة لوجستيات وكيلية هي الخيار الأنسب.',
      vsPrefix: 'Geofleet مقابل',
      alternativeSuffix: 'بديل',
      openLink: 'فتح المقارنة',
    },
    cta: {
      headline: 'شاهد Geofleet على شبكتك',
      subtext:
        'جولة في مركز قيادة الذكاء الاصطناعي والتخصيص والتوجيه الوكيلي مع محاورك وناقليك واتفاقيات مستوى الخدمة — وليس عرضاً عاماً.',
    },
    faqTitle: 'الأسئلة الشائعة',
    faqs: [
      {
        question: 'ما هي منصة لوجستيات وكيلية؟',
        answer:
          'المنصة الوكيلية تستخدم وكلاء ذكاء اصطناعي ومركز قيادة لتنسيق العمل بشكل مستقل: التخصيص والمسارات وإعادة التخطيط والتنبيهات واتصالات العملاء تتفاعل مع الظروف المباشرة بدلاً من الاعتماد فقط على قواعد ثابتة أو نقرات إرسال يدوية.',
      },
      {
        question: 'كيف تقارن Geofleet بأدوات تحسين المسارات؟',
        answer:
          'تركز محسّنات المسارات على ترتيب المحطات. تعامل Geofleet التوجيه كجزء من التنفيذ الكامل—تخصيص تلقائي بين السائقين والناقلين، تدفقات متعددة الأرجل ومحاور، بوابات شاحن وناقل، تتبع وتحليلات—حتى تثبت الخطط المحسّنة في التشغيل.',
      },
      {
        question: 'كيف تقارن Geofleet ببرامج آخر ميل؟',
        answer:
          'أدوات آخر ميل غالباً تدور حول المهام أو السائقين أو التوصيل المحلي. تستهدف Geofleet أتمتة لوجستية شاملة، بما في ذلك الوسط والأول عند الحاجة، ونظم شركاء وحوكمة اتفاقية مستوى الخدمة على نطاق واسع.',
      },
      {
        question: 'أين أرى مقارنة مباشرة مع مورّد محدد؟',
        answer:
          'انتقل إلى شبكة المورّدين — كل بطاقة تربط بصفحة Geofleet مقابل المورّد مع تفاصيل القدرات وتوازنات صريحة.',
      },
      {
        question: 'هل يجب أن أحجز عرضاً لمقارنة الخيارات؟',
        answer:
          'نعم. العروض أسرع طريقة لربط محاورك وناقليك وأحجامك وتكاملاتك بمركز القيادة ووكلاء الذكاء الاصطناعي في Geofleet.',
      },
    ],
  },
};
